const setSort = (state, action) => action.sort || state;

export default setSort;
